import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["skills", "empty"];
import React, { useMemo } from "react";
export var Skills = function Skills(_ref) {
  var skills = _ref.skills,
      empty = _ref.empty,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var regularSkills = useMemo(function () {
    return skills.filter(function (_ref2) {
      var additional = _ref2.additional;
      return !additional;
    });
  }, [skills]);
  var additionalSkills = useMemo(function () {
    return skills.filter(function (_ref3) {
      var additional = _ref3.additional;
      return additional;
    });
  }, [skills]);
  var showAdditionalSkills = additionalSkills.length !== 0;
  if (!skills.length && !empty) return null;
  return /*#__PURE__*/React.createElement("section", _extends({
    className: "skills"
  }, otherProps), /*#__PURE__*/React.createElement("h2", null, "Skills"), empty && /*#__PURE__*/React.createElement("p", null, "Click here to add your skills"), /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dd", null, /*#__PURE__*/React.createElement("ul", {
    className: "detailed"
  }, regularSkills.map(function (_ref4) {
    var name = _ref4.name;
    return /*#__PURE__*/React.createElement("li", {
      key: name
    }, /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, name)));
  }))), showAdditionalSkills && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, "Additional Skills"), /*#__PURE__*/React.createElement("dd", null, /*#__PURE__*/React.createElement("ul", {
    className: "additional"
  }, additionalSkills.map(function (_ref5) {
    var name = _ref5.name;
    return /*#__PURE__*/React.createElement("li", {
      key: name
    }, name);
  }), !additionalSkills.length && "No additional skills specified")))));
};